import { Amplify } from 'aws-amplify';

// Cognito configuration from deployment
const cognitoConfig = {
  region: 'us-west-2',
  userPoolId: 'us-west-2_tfOTVLtr6',
  userPoolWebClientId: 'b46ek1fan2hlo9b1q9k12mtfo',
  identityPoolId: 'us-west-2:6a5d5e50-7e44-43fe-aa71-1de71c56576c',
  domain: 'financial-overdue-us-west-2_tfotvltr6.auth.us-west-2.amazoncognito.com'
};

// Configure Amplify
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: cognitoConfig.userPoolId,
      userPoolClientId: cognitoConfig.userPoolWebClientId,
      identityPoolId: cognitoConfig.identityPoolId,
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: 'code',
      userAttributes: {
        email: {
          required: true,
        },
        given_name: {
          required: true,
        },
        family_name: {
          required: true,
        },
      },
      allowGuestAccess: false,
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: false,
      },
    },
  },
});

export { cognitoConfig };